import { ChangeDetectionStrategy, Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UserProfile } from '@auth/interfaces/user-profile.interface';
import { State } from '@auth/store';
import { LoadProfile } from '@auth/store/actions/auth.actions';
import { selectAuthUserProfile } from '@auth/store/selectors/profile.selectors';
import { selectIsAuthenticated } from '@auth/store/selectors/session.selectors';
import { CustomIconService } from '@core/services/custom-icon.service';
import { Store } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AppComponent implements OnInit {
  private readonly customIconService = inject(CustomIconService);
  private readonly store = inject<Store<State>>(Store);
  private readonly destroyRef = inject(DestroyRef);

  public title = 'Cerebro';
  private readonly isAuthenticated$: Observable<boolean>;
  private readonly userProfile$: Observable<UserProfile | null>;
  private backendlessAppInitiated: object | undefined;

  constructor() {
    this.customIconService.registerIcons();
    this.isAuthenticated$ = this.store.select(selectIsAuthenticated);
    this.userProfile$ = this.store.select(selectAuthUserProfile);
  }

  ngOnInit(): void {
    combineLatest([this.isAuthenticated$, this.userProfile$])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(([isAuthenticated, userProfile]) => {
        // console.log('isAuthenticated', isAuthenticated);
        // console.log('userProfile', userProfile);
        // console.log('appInitiated? 1', this.backendlessAppInitiated);
        if (isAuthenticated && !this.backendlessAppInitiated) {
          console.log('_RT_ initApp');
          const url = environment.api.split('/');
          Backendless.serverURL = `https://${url[2]}`;
          this.backendlessAppInitiated = Backendless.initApp(url[3], url[4]);
          // console.log('appInitiated? 2', this.backendlessAppInitiated);

          if (!userProfile) {
            // console.log('LoadProfile');
            this.store.dispatch(LoadProfile());
          }
        }
      });
  }
}
